<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="true" create-btn-title="新建公告"
                @btnHandler="btnHandler" @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.title" placeholder="公告标题" style="width: 300px;"></Input>
        </FormItem>
      </template>
      <template slot-scope="{row, index}" slot="top_hot">
        <Tag v-if="row.is_top" color="primary">置顶</Tag>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Tooltip content="编辑" placement="top" transfer>
          <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)"/>
        </Tooltip>
        <Poptip confirm title="确定要删除吗?" placement="left" @on-ok="btnHandler('delete', row)"
                @on-cancel="btnHandler('cancel', row)" transfer>
          <Button type="warning" size="small" icon="md-trash"></Button>
        </Poptip>
      </template>
    </page-table>

    <Modal width="900" :title="formData.title" v-model="formData.visible" @on-ok="onSubmit">
      <Form label-width="100">
        <FormItem v-for="item in formData.fields" :key="item.key" :label="item.label">
          <Input v-if="item.type === 'input'" v-model="formData.data[item.key]"/>
          <tinymce v-if="item.type === 'editor'" v-model="formData.data[item.key]" ></tinymce>
          <InputNumber v-if="item.type === 'number'" v-model="formData.data[item.key]"/>
          <i-switch v-if="item.type === 'switch'" v-model="formData.data[item.key]" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { delNotice, getNoticeList, saveNotice } from '../../api/article'
import tinymce from '../../components/tinymce/index'

export default {
  name: 'notice',
  components: { pageTable, tinymce },
  data () {
    return {
      params: {
        title: ''
      },
      tableLoading: false,
      tableColumns: [
        { title: '公告标题', key: 'title', width: 230 },
        { title: '公告详情', key: 'content' },
        { title: '推荐/置顶', key: 'top_hot', width: 100, slot: 'top_hot' },
        { title: '更新时间', key: 'update_time', align: 'right', width: 160 },
        { title: '创建时间', key: 'create_time', align: 'right', width: 160 },
        { title: '操作', slot: 'action', width: 100, align: 'center', fixed: 'right' }
      ],
      pageTotal: 0,
      tableData: [],
      formData: {
        visible: false,
        title: '',
        fields: [
          { label: '公告标题', key: 'title', type: 'input' },
          { label: '公告详情', key: 'content', type: 'editor' },
          { label: '是否置顶', key: 'is_top', type: 'switch' }
        ],
        data: {}
      }
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getNoticeList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    edit (row) {
      this.formData.visible = true
      this.formData.title = '修改公告'
      this.formData.data = { ...row }
    },
    new () {
      this.formData.visible = true
      this.formData.title = '新增公告'
      this.formData.data = {}
    },
    delete (row) {
      delNotice({ id: row.id }).then(({ data }) => {
        this.$Message.success({
          content: '删除成功~'
        })
        this.fetchData()
      })
    },
    cancel () {
    },
    onSubmit () {
      saveNotice({ ...this.formData.data }).then(({ data }) => {
        this.$Message.success({
          content: '保存成功~'
        })
        this.fetchData()
      })
    }

  }
}
</script>
